import {
  RiskSummariesDocument,
  RiskSummariesSummariesDocument,
  type RiskSummary,
} from "$/__generated__/graphql";
import { OverviewDataTables } from "components/tables";
import {
  RISK_SUMMARY_BASE_DEFS,
  RISK_SUMMARY_ROUNDING,
} from "constants/column-defs";
import { useGlobalFiltersContext } from "contexts/filters";
import {
  useDataTable,
  useDataTableSummaries,
  useSummariesFormatters,
} from "hooks/queries";
import { useAppliedColumns } from "hooks/useAppliedColumns";

export const SystemOverviewRiskSummaries = () => {
  const { hierarchyIds } = useGlobalFiltersContext();

  const {
    showFoot,
    systemMetric,
    selectionMetric,
    setSelectionMetric,
    setSystemMetric,
    setShowFoot,
    rows,
    loading,
    fetchMoreDataTable,
    isFetchingMore,
  } = useDataTable<RiskSummary>("riskSummaries", RiskSummariesDocument, {
    variables: {
      hierarchyIds,
    },
  });

  const appliedColumns = useAppliedColumns<RiskSummary>(
    "Risk",
    RISK_SUMMARY_BASE_DEFS,
  );

  const { columns } = useDataTableSummaries(
    appliedColumns,
    RiskSummariesSummariesDocument,
    {
      variables: {
        hierarchyIds,
        selectionMetricType: selectionMetric,
        systemMetricType: systemMetric,
      },
    },
    useSummariesFormatters(
      selectionMetric,
      systemMetric,
      RISK_SUMMARY_ROUNDING,
    ),
  );

  return (
    <OverviewDataTables
      loading={loading}
      data={rows}
      columns={columns}
      selectionValue={selectionMetric}
      systemValue={systemMetric}
      showFoot={showFoot}
      onSelectionChange={setSelectionMetric}
      onSystemChange={setSystemMetric}
      setShowFoot={setShowFoot}
      onFetchMore={fetchMoreDataTable}
      isFetchingMore={isFetchingMore}
    />
  );
};

export default SystemOverviewRiskSummaries;
